/**
 * TeamEvent constants. The calendar color visually distinguishes team events
 * from per-crew leaves on the shared Google Calendar.
 */

/** Google Calendar palette id (1-11); '9' (blueberry) — distinct from crew default '7'. */
export const TEAM_EVENT_CALENDAR_COLOR_ID = '9';

export const TEAM_EVENT_TITLE_MAX = 200;
export const TEAM_EVENT_DESC_MAX = 500;
